
import { Card, CardContent } from "@/components/ui/card";

const FAQSection = () => {
  const faqs = [
    {
      q: "Who qualifies for free access?",
      a: "Current and alumni members of recognized accelerator programs like Techstars, Y Combinator, 500 Global, and others. We verify membership through batch information and accelerator databases."
    },
    {
      q: "How long does verification take?",
      a: "Techstars and Y Combinator applications are typically approved within 24 hours. Other accelerator programs may take 2-3 business days for manual review."
    },
    {
      q: "What if my accelerator isn't listed?",
      a: "Apply through the 'Other Accelerators' form with details about your program. We're continuously adding new accelerators to our approved list."
    },
    {
      q: "Is there a time limit on access?",
      a: "Free access is ongoing for verified accelerator members. We believe in supporting the startup ecosystem long-term."
    },
    {
      q: "Can I access ScoutLink.ai if I'm not in an accelerator?",
      a: "Currently, we're in closed beta for accelerator members only. Contact us at hello@scoutlink.ai for enterprise inquiries."
    },
    {
      q: "What data do you need for verification?",
      a: "Company name, your email, accelerator name, batch/cohort, and brief company description. We may request additional verification for some programs."
    }
  ];

  return (
    <section className="container mx-auto px-6 py-20">
      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
      </div>

      <div className="max-w-3xl mx-auto space-y-6">
        {faqs.map((faq, index) => (
          <Card key={index}>
            <CardContent className="pt-6">
              <h3 className="font-semibold text-lg mb-3">{faq.q}</h3>
              <p className="text-gray-600">{faq.a}</p>
            </CardContent>
          </Card>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
